export const SKELETON_HEIGHT = 20;
